module.exports = __webpack_public_path__ + "img/logo.3cbae37.png";